import $ from "jquery";

$(document).ready(() => {
    $(".mobile-nav-toggle").on('click', function (e) {
        const hasClass = $(".mobile-nav-toggle").hasClass("fa-bars")
        if (hasClass) {
            $("#navbar").addClass("navbar-mobile");
            $(".mobile-nav-toggle").removeClass("fa-bars");
            $(".mobile-nav-toggle").addClass("fa-times");
        } else {
            $("#navbar").removeClass("navbar-mobile");
            $(".mobile-nav-toggle").addClass("fa-bars");
            $(".mobile-nav-toggle").removeClass("fa-times");
        }
    })

    $(".navbar_items li").off().on("click", function () {
        $(".navbar_items li").removeClass("active");
        $(this).addClass("active");
    })


    $("#menu-filters li").on("click", function () {
        $("#menu-filters li").removeClass("filter-active");
        $(this).addClass("filter-active");
    });
    $("#navbar_items li a").on("click", function () {
        debugger;
        const _var = this;
        sessionStorage.setItem("ActiveLink", _var);
        $("#navbar_items li a").removeClass("active");
        $(_var).addClass("active");
    });
})

export const HomeHeader = () => {
    var header = $("#header");
    header.css("background", "rgba(26, 24, 22, 0)");
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 500) {
            header.css("background", "rgba(26, 24, 22, 0.85)")
        } else {
            header.css("background", "rgba(26, 24, 22, 0)")
        }
    });
}


export const changeHeaderBackGround = () => {
    $("#header").css("background", "rgb(26, 24, 22)")
}

export const ActiveLink = () => {
    debugger;
    const ActiveLink = sessionStorage.getItem("ActiveLink");
    $("#navbar_items li a").removeClass("active");
    $(ActiveLink).addClass("active");
}